export default __webpack_public_path__ + "static/progress-70215558a13e3a81c4659b555dc34481.png";